import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  GetPlanById200,
  GetPlanById404,
  GetPlans200Item,
  GetPlans400,
  GetPlans404,
  GetPlans500,
  GetPlansByProductCode200Item,
  GetPlansByProductCode404,
  GetPlansParams
} from './types'
import { customInstance } from '../custom-axios';


type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


/**
 * Retrieve a list of plans for a specific product code
 * @summary Get plans by product code
 */
export const getPlans = (
    params?: GetPlansParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlans200Item[]>(
      {url: `/api/v1/plans`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getGetPlansQueryKey = (params?: GetPlansParams,) => {
    return [`/api/v1/plans`, ...(params ? [params]: [])] as const;
    }

    
export const getGetPlansInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getPlans>>, TError = GetPlans400 | GetPlans404 | GetPlans500>(params?: GetPlansParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlans>>> = ({ signal }) => getPlans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlansInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPlans>>>
export type GetPlansInfiniteQueryError = GetPlans400 | GetPlans404 | GetPlans500

/**
 * @summary Get plans by product code
 */
export const useGetPlansInfinite = <TData = Awaited<ReturnType<typeof getPlans>>, TError = GetPlans400 | GetPlans404 | GetPlans500>(
 params?: GetPlansParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlansInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPlansQueryOptions = <TData = Awaited<ReturnType<typeof getPlans>>, TError = GetPlans400 | GetPlans404 | GetPlans500>(params?: GetPlansParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlans>>> = ({ signal }) => getPlans(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlansQueryResult = NonNullable<Awaited<ReturnType<typeof getPlans>>>
export type GetPlansQueryError = GetPlans400 | GetPlans404 | GetPlans500

/**
 * @summary Get plans by product code
 */
export const useGetPlans = <TData = Awaited<ReturnType<typeof getPlans>>, TError = GetPlans400 | GetPlans404 | GetPlans500>(
 params?: GetPlansParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlans>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlansQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve detailed information about a specific plan
 * @summary Get plan details by ID
 */
export const getPlanById = (
    planId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlanById200>(
      {url: `/api/v1/plans/${planId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPlanByIdQueryKey = (planId: string,) => {
    return [`/api/v1/plans/${planId}`] as const;
    }

    
export const getGetPlanByIdInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getPlanById>>, TError = GetPlanById404>(planId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanByIdQueryKey(planId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanById>>> = ({ signal }) => getPlanById(planId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(planId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlanByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanById>>>
export type GetPlanByIdInfiniteQueryError = GetPlanById404

/**
 * @summary Get plan details by ID
 */
export const useGetPlanByIdInfinite = <TData = Awaited<ReturnType<typeof getPlanById>>, TError = GetPlanById404>(
 planId: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlanByIdInfiniteQueryOptions(planId,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPlanByIdQueryOptions = <TData = Awaited<ReturnType<typeof getPlanById>>, TError = GetPlanById404>(planId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlanByIdQueryKey(planId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlanById>>> = ({ signal }) => getPlanById(planId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(planId),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlanByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPlanById>>>
export type GetPlanByIdQueryError = GetPlanById404

/**
 * @summary Get plan details by ID
 */
export const useGetPlanById = <TData = Awaited<ReturnType<typeof getPlanById>>, TError = GetPlanById404>(
 planId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlanById>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlanByIdQueryOptions(planId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve plans for a specific product code using path parameter
 * @summary Get plans by product code (alternative endpoint)
 */
export const getPlansByProductCode = (
    productCode: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<GetPlansByProductCode200Item[]>(
      {url: `/api/v1/products/${productCode}/plans`, method: 'GET', signal
    },
      options);
    }
  

export const getGetPlansByProductCodeQueryKey = (productCode: string,) => {
    return [`/api/v1/products/${productCode}/plans`] as const;
    }

    
export const getGetPlansByProductCodeInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof getPlansByProductCode>>, TError = GetPlansByProductCode404>(productCode: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansByProductCodeQueryKey(productCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlansByProductCode>>> = ({ signal }) => getPlansByProductCode(productCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productCode),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlansByProductCodeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPlansByProductCode>>>
export type GetPlansByProductCodeInfiniteQueryError = GetPlansByProductCode404

/**
 * @summary Get plans by product code (alternative endpoint)
 */
export const useGetPlansByProductCodeInfinite = <TData = Awaited<ReturnType<typeof getPlansByProductCode>>, TError = GetPlansByProductCode404>(
 productCode: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlansByProductCodeInfiniteQueryOptions(productCode,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getGetPlansByProductCodeQueryOptions = <TData = Awaited<ReturnType<typeof getPlansByProductCode>>, TError = GetPlansByProductCode404>(productCode: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlansByProductCodeQueryKey(productCode);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlansByProductCode>>> = ({ signal }) => getPlansByProductCode(productCode, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(productCode),  staleTime: 300000, gcTime: 1800000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlansByProductCodeQueryResult = NonNullable<Awaited<ReturnType<typeof getPlansByProductCode>>>
export type GetPlansByProductCodeQueryError = GetPlansByProductCode404

/**
 * @summary Get plans by product code (alternative endpoint)
 */
export const useGetPlansByProductCode = <TData = Awaited<ReturnType<typeof getPlansByProductCode>>, TError = GetPlansByProductCode404>(
 productCode: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlansByProductCode>>, TError, TData>, request?: SecondParameter<typeof customInstance>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetPlansByProductCodeQueryOptions(productCode,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



